import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export interface GlassCard {
  id: string;
  label: string;
  value: string | number;
  hasIssue?: boolean;
  hasWarning?: boolean;
}

@Component({
  selector: 'tidy-glass-cards',
  templateUrl: './glass-cards.component.html',
  styleUrls: ['./glass-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlassCardsComponent {
  @Input() cards: GlassCard[] = [];
  @Output() cardClick = new EventEmitter<string>();

  onCardClick(card: GlassCard): void {
    this.cardClick.emit(card.id);
  }
}
